export const isValidPhone = (phone) => {
  return /^[0-9]{5,15}$/.test(phone);
};
